import { LocalStorageKey, useGetUserData } from "common/helpers/userData";

export const useRole = () => {
  return useGetUserData(LocalStorageKey.SelectedRole)?.value;
};
